import React, { useEffect, useState } from "react"
import { Button, Input, Table } from "reactstrap"
import { getQuoteRequest, getRejectRedeemQuote } from "../services/waitlist-service";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import middlewareConstants from "../../shared/middleware-constant";
import { middlewareService } from "../../shared/service";
import InfoPopup from "./InfoPopup";

export default function LiquidationFirst(props) {
    const history = useHistory();
    const [checked, setChecked] = useState(false);
    const [checkedTwo, setCheckedTwo] = useState(false);
    const [disable, setDisable] = useState(false);
    const [showSection, setShowSection] = useState(true);
    const [netPrice, setNetPrice] = useState();
    const [liquidationAmount, setLiquidationAmount] = useState();
    const [showPopUpText, setShowPopupText] = useState(false);
    const [popUpOverText, setPopUpOverText] = useState("");

    const setConsent = () => {
        let _url = "/users/setConsent";
        let payload = {
            type: "redeem",
            consent: true

        };
        let requestOptions = middlewareConstants.requestWithCredentialsJsonBSE;
        requestOptions.body = new URLSearchParams(payload);
        middlewareService
            .servicePost(process.env.REACT_APP_REPORTS_API_URL + _url, requestOptions)
            .then((response) => {
                if (!response || !response.successs) {
                    console.log("something went wrong");
                }
            });
    };

    const handleClick = () => {
        if (props?.liquidationDetails?.availableUnits < 1) {
            return toast.error("Insufficient eligible unit")
        } else {
            setConsent()
            getQuoteRequest(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, props.units, 0).then(
                (res) => {
                    if (res) {
                        props.showSecond(true)
                        setDisable(true)
                        setShowSection(false)
                    }
                },
                (err) => {
                    toast.error("Error calling the API:", err);
                }
            );
        }
    }

    const handleNotLive = () => {
        history.push('/portfolio')
    }

    const handleInfoLockedClick = () => {
        setShowPopupText(!showPopUpText)
        setPopUpOverText("This price will be same till T+3 working days from the date of order placed.")
    }

    useEffect(() => {
        if (props) {
            // setLiquidationAmount(props?.liquidationDetails?.ispUnitPrice);
            setLiquidationAmount(props?.liquidationDetails?.unitPrice * ((100 - props?.liquidationDetails?.exitLoadInPerc) / 100));
            // setLiquidationAmount(amount)
        }
    }, [props])

    const handleCancelClick = () => {
        history.push('/portfolio')
    }

    useEffect(() => {
        setNetPrice(props?.liquidationDetails?.unitPrice * ((100 - props?.liquidationDetails?.exitLoadInPerc) / 100))
    }, [props])

    return (
        <div className="table-wrapper">
            <Table bordered className="text-center liq-table">
                <th className="header" colSpan={2}>Liquidation Overview</th>
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">Issue details</td>
                    <td className="w-50 font-weight-semi-bold">{props?.bondDetails?.productName}</td>
                </tr>
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">Price per unit</td>
                    <td className="w-50 font-weight-semi-bold">{props?.liquidationDetails?.unitPrice.oroNumber(2, true)}</td>
                    {/* <td className="w-50 font-weight-semi-bold">{props?.liquidationDetails?.priceWithoutExitLoad.oroNumber(2, true)}</td> */}
                </tr>
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">Liquidation cost</td>
                    <td className="w-50 font-weight-semi-bold">{props?.liquidationDetails?.exitLoadInPerc}%</td>
                </tr>
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">Redemption price per unit
                        <span
                            onClick={handleInfoLockedClick}
                            className="mdi mdi-information-outline ml-2"
                            style={{
                                cursor: "pointer",
                                fontSize: "15px",
                            }}
                        />
                    </td>
                    <td className="w-50 font-weight-semi-bold">{liquidationAmount ? liquidationAmount.oroNumber(2, true) : null}</td>
                </tr>
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">Total units available</td>
                    <td className="w-50 font-weight-semi-bold">{props?.liquidationDetails?.availableUnits}</td>
                </tr>
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold ">Enter units to be liquidated</td>
                    {showSection ?
                        <td>
                            <div className='input-units'>
                                <div className='d-flex ip'>
                                    <Button onClick={props.decreaseUnits} disabled={!props?.liquidationDetails?.availableUnits} className="ip-btn">-</Button>
                                    <Input
                                        style={props.units <= 0 ? { color: "#cfcfcf", fontSize: "12px" } : {}}
                                        value={props.units <= 0 ? "Enter Units" : props.units}
                                        onChange={(e) => props?.setUnitsFunc(e.target.value)}
                                        pattern="[0-9]*"
                                        inputMode="numeric"
                                        placeholder="Enter Units"
                                        disabled={!props?.liquidationDetails?.availableUnits}
                                        className="text-center inp"
                                    />
                                    <Button onClick={props?.increaseUnits} disabled={!props?.liquidationDetails?.availableUnits} className="ip-btn">+</Button>
                                </div>
                            </div>
                        </td> :
                        <td className="w-50 font-weight-semi-bold">{props?.units}</td>
                    }
                </tr>
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">Total redemption amount</td>
                    <td className="w-50 font-weight-semi-bold">{netPrice ? (props?.units * netPrice).oroNumber(2, true) : ""}</td>
                </tr>
            </Table>

            {props?.liquidationDetails?.availableUnits >= 1 ? <>{!props.redemptionSuccess && <>{showSection &&
                <>
                    <div className="mt-5 mb-2 text-center">
                        <p className="footer ">
                            <input type="checkbox"
                                defaultChecked={checked}
                                onChange={() => setChecked(!checked)}
                            />&nbsp;
                            By proceeding, I accept the &nbsp;
                            <a className="text-secondary" target="_blank" href={process.env.REACT_APP_URL_ENDPOINTS + "/terms-of-use/"}><b>Terms & Conditions</b></a>
                        </p>
                    </div>
                    <div className="bottom-sec text-center mb-5">
                        <div className="btn-holder">
                            <Button outline onClick={handleCancelClick}>Cancel Now</Button>
                            <Button onClick={handleClick} disabled={(!checked)}>Liquidate Now</Button>
                        </div>
                    </div>
                </>
            }</>
            }</> : <><p className="inactive-market text-center font-weight-semi-bold">
                You don’t have any eligible units to liquidate now. Please contact us on +91 8591871028 or +91 8928250817 or email us to <a href='mailto:connect@biddeasy.com'>connect@biddeasy.com</a> for any queries.”
            </p>
                <div className="btn-holder">
                    <Button outline onClick={handleNotLive}>Close</Button>
                </div>
            </>}

            {
                popUpOverText &&
                <InfoPopup
                    showPopUpText={showPopUpText}
                    toggleInfoPopup={handleInfoLockedClick}
                    text={popUpOverText}
                />
            }

        </div>
    )
}